// extracted by mini-css-extract-plugin
export default {"container":"GF-z","innerContainer":"HF-z","multipleLines":"IF-z","heading":"JF-z","content":"KF-z","linkColor":"LF-z"};